import InfoModal from './InfoModal';
import styles from './DatosAsambleaModal.module.css';

export default function DatosAsambleaModal({ assembly, onClose }) {
  const fmt = (d) => d ? new Date(d).toLocaleString('es-CO', {
    day: '2-digit', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit',
  }) : '—';
  const modalidadLabel = {
    virtual: 'Virtual', inplace: 'Presencial', hybrid: 'Híbrida',
  };
  const rows = [
    ['Conjunto',      assembly.property?.name],
    ['N° Asamblea',   `#${assembly.number_assembly}`],
    ['Tipo',          assembly.assembly_type || '—'],
    ['Modalidad',     modalidadLabel[assembly.assembly_model] || assembly.assembly_model || '—'],
    ['Fecha inicio',  fmt(assembly.start_date || assembly.date)],
    ['Quórum requerido', `${assembly.quorum || '—'}%`],
    ['Estado',        assembly.status],
  ];
  return (
    <InfoModal title="Datos de la asamblea" icon="fa-circle-info" color="#6c63ff" onClose={onClose}>
      <table className={styles.tabla}>
        <tbody>
          {rows.map(([label, val], i) => (
            <tr key={label} className={`${styles.fila} ${i % 2 === 0 ? styles.filaConFondo : ''}`}>
              <td className={styles.celdaEtiqueta}>{label}</td>
              <td className={styles.celdaValor}>{val || '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </InfoModal>
  );
}
